import { useContext } from "react"
import { DesignEditorContext } from "~/contexts/DesignEditor"

function useDesignEditorContext() {
  const {
    editorType,
    setEditorType,
    contentKind,
    setContentKind,
    activeFormat,
    setActiveFormat,
    setDisplayPreview,
    displayPreview,
    displayAnimation,
    setDisplayAnimation,
    animationPreset,
    setAnimationPreset,
    animationPlaying,
    setAnimationPlaying,
    currentScene,
    setCurrentScene,
    setScenes,
    scenes,
    maxTime,
    setMaxTime,
    contextMenuTimelineRequest,
    setContextMenuTimelineRequest,
    contextMenuSceneRequest,
    setContextMenuSceneRequest,
    currentDesign,
    setCurrentDesign,
  } = useContext(DesignEditorContext)
  return {
    editorType,
    setEditorType,
    contentKind,
    setContentKind,
    activeFormat,
    setActiveFormat,
    setDisplayPreview,
    displayPreview,
    displayAnimation,
    setDisplayAnimation,
    animationPreset,
    setAnimationPreset,
    animationPlaying,
    setAnimationPlaying,
    currentScene,
    setCurrentScene,
    setScenes,
    scenes,
    maxTime,
    setMaxTime,
    contextMenuTimelineRequest,
    setContextMenuTimelineRequest,
    contextMenuSceneRequest,
    setContextMenuSceneRequest,
    currentDesign,
    setCurrentDesign,
  }
}

export default useDesignEditorContext
